import globalConfig from 'init/global.config'
import { hostsConfig } from 'init/config'
import { ssoGetLoggedInData } from 'services/sso-service'
import { TurnToFlow } from './email-flow-entry'
import submissionLoader from 'widgets/submission/submission-loader'
import submissionStore, { SellerRatingLaunchData, SubmissionPage } from 'store/submission-store'

const SELLER_RATING_FLOW_KEYS = ['sellerrating']

/**
 * These flows are seller rating flows.  Currently, there is only one flow.
 *
 * @param flow
 * @param params
 * @param data
 */
export function checkForFlow(
  flow: TurnToFlow,
  params: { [name: string]: string }
): Promise<boolean> {
  return new Promise((resolve) => {
    if (SELLER_RATING_FLOW_KEYS.indexOf(flow) > -1) {
      const launchData = { emailToken: params.token } as SellerRatingLaunchData
      if (params.starSelected) {
        launchData.starSelected = parseInt(params.starSelected) || 0
        if (launchData.starSelected < 0 || launchData.starSelected > 5) {
          launchData.starSelected = undefined
        }
      }
      const submissionPage = { page: 'seller-rating-form', props: {} } as SubmissionPage
      if (globalConfig.ssoEnabled) {
        ssoGetLoggedInData(null, submissionPage, null, null, launchData)
        resolve(true)
        return
      }
      submissionStore.startSellerRatingFlow(
        hostsConfig.siteKey,
        { page: 'seller-rating-form', props: {} } as SubmissionPage,
        launchData
      )
      submissionLoader.load()
      resolve(true)
    } else {
      resolve(false)
    }
  })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/email-flows/seller-rating-flows.ts